/**
 * Model reprezentujący pojedynczą metodę płatności (kanał) dostępną w bramce Przelewy24.
 */
export class PaymentMethodP24 {

  public name: string;
  public id: number;
  public status: boolean;
  public imgUrl: string;
  public mobileImgUrl: string;
  public mobile: boolean;
  public availabilityHours: string;

  constructor() {
  }
}

export class AvailabilityHours {
  public mondayToFriday: string;
  public saturday: string;

  constructor() {
  }
}
